module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-box"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('Policy')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('PolicyDescribe')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('updateData')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('acceptPolicy')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('acceptPolicyDes')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('acceptPolicyDescribe')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('infoCollect')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('infoCollectDes')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('infoCollectDescribe')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('infoCollectDetail')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('safety')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('safetyDescribe')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('personal')))]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v(_vm._s(_vm.$t('personalDescribe')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('email')) + "iplexservice@gmail.com")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fc527ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacyTerms/PrivacyTerms.vue
// module id = 1274
// module chunks = 1